import { useCallback } from 'react';
import { trackAnalytics } from 'common/components/CopyMagic/shared/dataHelpers';
import { useConfigContext } from 'common/components/CopyMagic/contexts';
import { PromptFormValuesType } from 'common/components/CopyMagic/CopyMagic.types';

const useTrackOnGenerate = () => {
  const { productEvents } = useConfigContext();

  const trackCallback = useCallback(
    ({ promptValues }: { promptValues: PromptFormValuesType }) => {
      const trackProductAnalytics = trackAnalytics(productEvents);

      trackProductAnalytics('Prompt Sent', { Input: promptValues.topic });
    },
    [productEvents],
  );

  return trackCallback;
};

export default useTrackOnGenerate;
